export default __webpack_public_path__ + "static/media/ap-card-clock.e9d50224.svg";